/**
 * Created by toomasp on 10.08.2015.
 */
"use strict";

import template from './simple-table.html';

export default ["config", "root", (config, root) => {
    class SimpleTableDirective {
        restrict = 'A';
        scope = {
            model: '=simpletable'
        };

        replace = true;
        template = template;

        link(scope) {
            scope.root = root;
            scope.getColumnValue = (col) => {
                if (typeof col === 'function') {
                    return col();
                }
                return col;
            };
        }
    }

    return new SimpleTableDirective();
}];



// WEBPACK FOOTER //
// ./src/ui/core/common/directives/widget/table/simple-table.directive.js